






import {Component, Vue, Watch} from 'vue-property-decorator';
import AuthService from "@/services/auth_service";

@Component({
  name: 'HomeRedirect',
  components: {
  }
})


export default class extends Vue {

  public authSevice = AuthService;

  async created() {

    await this.$router.push('/input/losses');


  }

  async mounted() {

  }

  destroyed() {

  }

  empty() {
    //
  }

}
